import React from 'react';
import { connect } from 'react-redux'
import { Button, Glyphicon } from 'react-bootstrap';
import uuidv4 from 'uuid/v4'
import { DataType } from './constant'

class AddConfigurationElementObject extends React.Component {
    constructor(props) {
        super(props);
    }

    groupBy(list, keyGetter) {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item.path]);
            } else {
                collection.push(item.path);
            }
        });
        return map;
    }

    onAdd() {
        let elements = []

        //initial fields to be added.
        let fields = ['*', 'hw_sap_no_rev', 'type', 'sw_sap_no_ver']

        //get the fields from the this.props.fields array. NOTE: this.props.fields is from database.
        let newElementObjects = this.props.fields.filter(function (x) {
            return fields.indexOf(x.field) != -1
        });

        //get the one level child of object grouped by Path.
        let grouped = this.groupBy(this.props.configurations,
            x => x.path.length > this.props.path.length && x.path.length < this.props.path.length + 4).get(true)

        //get distinct path
        let paths = Array.from(new Set(grouped))

        //Now we know the index of path where to put these fields.
        let newPath = 'configuration.elements[' + paths.length + ']';

        let objectId = uuidv4();

        let sequence = 1
        newElementObjects.forEach(element => {
            elements.push({
                id: element.type === DataType.Object ? objectId : uuidv4(),
                fieldDefinitionId: element.id,
                fieldName: element.field,
                dataType: element.type,
                tag: 0,
                parentId: element.type === DataType.Object ? this.props.arrayId : objectId,
                arrayIndex: element.type === DataType.Object ? paths.length : 0, //check if field tye is object.
                sequence: (element.type === DataType.Object || element.field === 'type') ? 0 : sequence++, //check if field tye is object.
                includeInRecipe: true,
                readOnly: false,
                value: '',
                isDeleted: false,
                path: newPath,
                displayValue: null
            });
        });

        this.props.onAdd(elements, newPath)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            fields: nextProps.fields
        })
    }

    render() {
        return (
            <Button
                bsSize="xs"
                bsStyle="success"
                onClick={this.onAdd.bind(this)}
            >
                <Glyphicon glyph="plus" />
            </Button>          
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        fields: state.configuration.elementProperties.fields
    }
}

export default connect(mapStateToProps)(AddConfigurationElementObject);
